import { ExperimentPaymentPlanVariant } from '@customer-frontend/graphql-types';

export const getNumberOfOrdersFromVariant = (
  variant: ExperimentPaymentPlanVariant,
): number => Number.parseInt(variant.split('_')[1], 10);
